module.exports = {
  ID: { pl: 'ID', width: '10%' },
  TITLE: { pl: 'Nazwa', width: '50%', type: 'text', req: true },
  NIP: { pl: 'NIP', width: '30%', type: 'text' },
  save: { }
}
